import { ReviewsServiceName } from "@bluframe/mightychroma-mightytool-frontend-types"

import OverridesScoreQuoteAndSection from "./OverridesScoreQuoteAndSection"

export type ReviewSectionUpdate = {
  quote?: string
  score?: number
  section?: string
}

export interface Props {
  inputId: string
  label: string
  name: string
  onUpdate: (update: ReviewSectionUpdate) => void
  quote?: string
  score?: number
  section?: string
  serviceName: ReviewsServiceName
}

export interface ComponentProps extends Props {}

export default OverridesScoreQuoteAndSection
